/* eslint-disable @next/next/no-img-element */
import React, {FC} from 'react'

import imageWaterMarkNotCheck from 'src/assets/images/doc-not-check.png'
import imageWaterMarkPreview from 'src/assets/images/doc-preview.png'

interface IPreviewWaterMarkProps {
	isPreviewMark?: boolean
	isCheckMark?: boolean
	className?: string
}

const PreviewWaterMark: FC<IPreviewWaterMarkProps> = ({
	isPreviewMark = true,
	isCheckMark = true,
	className,
}) => {
	const wrapperClassName = className ? `watermark-wrapper ${className}` : 'watermark-wrapper'
	return (
		<div className={wrapperClassName}>
			<div className="watermark-cover" />
			{isPreviewMark && (
				<div className="watermark-preview">
					<img className="watermark-img" src={imageWaterMarkPreview.src} alt="Preview only" />
				</div>
			)}
			{isCheckMark && (
				<div className="watermark-check">
					<img src={imageWaterMarkNotCheck.src} alt="Do not check" />
				</div>
			)}
		</div>
	)
}

PreviewWaterMark.displayName = 'PreviewWaterMark'

export default PreviewWaterMark
